import React from 'react';

const Footer = () => {
    return (  
        <footer className="footer">
            <div className="container-fluid">
                <nav className="float-left">
                    <ul>
                        <li>
                            <a href="https://www.insightplusedu.com" target="_blank" rel="noopener noreferrer">InsightPlus</a>
                        </li>
                        <li>
                            <a href="https://www.insightplusedu.com/about.html" target="_blank" rel="noopener noreferrer">About Us</a>
                        </li>
                    </ul>
                </nav>
            </div>
        </footer>
    );
}
 
export default Footer;